<template>
    <div class="assets-transfer">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.go(-1);">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">Create Assets</div>
                    </div>
                </div>
            </div>

            <hr />
        </div>

        <div class="container mt-5">

            <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                Tablet updated successfully.
            </div>
            <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
                Please fill in the mandatory field(s).
            </div>

            <div >

                <div class="form-group">
                    <label for="">Asset Type *</label>

                    <div>
                        <div class="custom-control-inline pill-radio">
                            <input type="radio" id="tablet" name="type" value="tablet" required class="custom-control-input" v-model="selectedType">
                            <label class="" for="tablet">Tablets</label>
                        </div>
                        <div class="custom-control-inline pill-radio">
                            <input type="radio" id="uniform" name="type" value="uniform" required class="custom-control-input" v-model="selectedType">
                            <label class="" for="uniform">Uniform</label>
                        </div>
                    </div>
                </div>

                <h3 class="section-title mt-5">Asset Location</h3>

                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.formData.filter.division.$error }">
                            <label for="">Division *</label>

                            <div>
                                <div class="custom-control-inline pill-radio">
                                    <input type="radio" id="north" name="division" value="0" required class="custom-control-input" v-model="formData.filter.division" @change="onChangeDivision">
                                    <label class="" for="north">East</label>
                                </div>
                                <div class="custom-control-inline pill-radio">
                                    <input type="radio" id="south" name="division" value="1" required class="custom-control-input" v-model="formData.filter.division" @change="onChangeDivision">
                                    <label class="" for="south">West</label>
                                </div>
                            </div>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.formData.filter.division.required">Division is required</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.formData.filter.region.$error }">
                            <label for="">Region *</label>
                            <select class="custom-select form-control" name="region" id="region" required v-model="formData.filter.region" @change="onChangeRegion">
                                <option :value="region.id" :key="region.id" v-for="region in filterRegions">{{ region.name }}</option>
                            </select>

                            <div class="invalid-feedback form-error-msg" v-if="!$v.formData.filter.region.required">Region is required</div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group" :class="{ 'form-is-error': $v.formData.filter.area.$error }">
                            <label for="">Area *</label>
                            <select class="custom-select form-control" name="area" id="area" required v-model="formData.filter.area">
                                <option :value="area.id" :key="area.id" v-for="area in filterAreas">{{ area.name }}</option>
                            </select>
                            <div class="invalid-feedback form-error-msg" v-if="!$v.formData.filter.area.required">Area is required</div>
                        </div>
                    </div>
                </div>

                <h3 class="section-title mt-4">Add New Asset</h3>

                <div class="table-responsive form-group" :class="{ 'form-is-error': $v.formData.tablets.$anyError }">

                    <div class="invalid-feedback form-error-msg" v-if="!$v.formData.tablets.required">Highlighted fields are required</div>
                    <div class="invalid-feedback form-error-msg" style="display: block" :id="index" :key="index" v-for="(error, index) in errors">{{ formData.tablets[index].imei + ' has been taken' }}</div>

                    <table class="table table-striped result-table table-form">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="">Name</th>
                                <th class="">IMEI Number</th>
                                <th class="">Status</th>
                                <th class="w-50">Remarks</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :key="item.id" v-for="item in formData.tablets">
                                <td>
                                    <div class="remove-row" v-if="formData.tablets.length > 1" @click="removeTabletAsset(item.id)">Remove</div>
                                </td>
                                <td>
                                   <input class="form-control" type="text" required v-model="item.sku">
                                </td>
                                <td>
                                    <input class="form-control" type="text" required v-model="item.imei" @input="errors = []">
                                </td>
                                <td>
                                    <select class="custom-select form-control" id="status" required v-model="item.status">
                                        <option value="available">Available</option>
                                        <option value="occupied">Occupied</option>
                                        <option value="damaged">Damaged</option>
                                    </select>
                                </td>
                                <td>
                                    <input class="form-control" type="text" required v-model="item.remarks">
                                </td>
                            </tr>


                            <tr class="table-footer">
                                <td colspan="7">
                                    <button type="button" class="btn btn-link p-0" @click="addTabletAsset">
                                        <span class="icon-plus">Add</span> Add Asset
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>

                <button type="submit" class="mt-3 btn btn-ecdc btn-shadow" @click="checkForm">Create</button>
                <button type="button" class="mt-3 btn btn-link" @click="$router.go(-1)">Cancel</button>
            </div>

        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
import Loader from "./Loader";
import { required } from 'vuelidate/lib/validators';
import {getAreas, getRegions, storeTabletAsset} from "../api";

export default {
    components: {
        appLoader: Loader,
    },
    data() {
        return {
            selectedType: 'tablet',
            regions: [],
            areas: [],
            formData: {
                filter: {
                    division: '',
                    region: '',
                    area: ''
                },
                tablets: [{
                    sku: '',
                    imei: '',
                    status: 'available',
                    remarks: ''
                }]
            },
            isLoading: true,
            isError: false,
            isSuccess: false,
            hasError: false,
            toggleFilter: true,
            totalPage: 0,
            pageLimit: 15,
            tabletData: '',
            showingResults: '',
            errors: {},
        }
    },
    computed: {
        filterRegions: function() {
            return this.regions.filter((item) => {
                if(this.formData.filter.division === '') {
                    return item;
                } else {
                    return item.division == this.formData.filter.division
                }
            });
        },
        filterAreas: function() {
            return this.areas.filter((item) => {
                if(this.formData.filter.region === '') {
                    return item;
                } else {
                    return item.region_id == this.formData.filter.region
                }
            });
        },
    },
    validations: {
        formData: {
            filter: {
                division: {
                    required
                },
                region: {
                    required
                },
                area: {
                    required
                }
            },
            tablets: {
                $each: {
                    sku: {
                        required
                    },
                    imei: {
                        required
                    },
                    status: {
                        required
                    }
                }
            }
        },
    },
    async mounted() {
        await this.getRegions();
        await this.getAreas();
        this.isLoading = false;
    },
    methods: {
        checkForm() {
            const _this = this;
            this.$v.formData.$touch();

            if(this.$v.formData.$invalid) {

                this.isError = true;
                window.scrollTo(0, 0);

                setTimeout(function() {

                    _this.isError = false;
                }, 2000);
            } else {
                this.storeTabletAssets();
            }
        },
        async storeTabletAssets() {
            let _this = this;
            this.$nextTick(function () {
                this.errors = [];
            });

            this.isLoading = true;

            try {

                await storeTabletAsset({formData: this.formData});

                this.isSuccess = true;

                window.scrollTo(0, 0);

                setTimeout(function() {

                    _this.isSuccess = false;
                    _this.$router.push({ name: "assetsTabletsDetails" });
                }, 2000);
            } catch (err) {

                this.$nextTick(function () {
                    this.errors = err.response.data.errors;

                    Object.keys(this.errors).map(function(key) {
                        let remove1 = key.replace('formData.tablets.', '');
                        let newkey = remove1.replace('.imei', '');
                        _this.errors[newkey] = _this.errors[key];
                        delete _this.errors[key];

                    });
                });

                alert(err.response.data.message);

            }

            this.isLoading = false;
        },
        addTabletAsset() {
            let object = {
                sku: '',
                imei: '',
                status: 'available',
                remarks: ''
            };

            this.formData.tablets.push(object);
        },
        removeTabletAsset(index) {
            this.formData.tablets.splice(index, 1);
        },
        async getRegions() {

            try {
                const result = await getRegions();
                this.regions = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        async getAreas() {

            try {
                const result = await getAreas();
                this.areas = result.data.data;
            }
            catch(err) {
                alert(err.response.data.message);
            }
        },
        onChangeDivision() {
            this.formData.filter.region = '';
            this.formData.filter.area = '';
        },
        onChangeRegion() {
            this.formData.filter.area = '';
        }
    }
}
</script>